import * as React from "react";
import { App } from "./app"

interface ImageButtonVm {
    FilenameBase: string
    TooltipText: string
    Width: string
    Height: string
    app: App
    buttonID: string
}

// ImageButton is a general buttonlike control, displayed through images for each of its states. 
// Clicks on these buttons are passed on to a handler within BDKalkCore, where various actions
// will take place depending on the buttonID property of the clicked button (given within App.render())
export class ImageButton extends React.Component<ImageButtonVm, {}> {
    constructor(props: ImageButtonVm) {
        super(props)
    }

    onClick() {
        this.props.app.GetCore().HandleButton(this.props.buttonID)
    }

    mouseOutHandler(e: React.MouseEvent<HTMLImageElement>) {
        e.currentTarget.src = 'images/' + this.props.FilenameBase + '.png';
    }

    mouseOverHandler(e: React.MouseEvent<HTMLImageElement>) {
        e.currentTarget.src = 'images/' + this.props.FilenameBase + 'Hover.png'
    }

    render() {
        const baseName = this.props.FilenameBase;
        const wide = this.props.Width;
        const high = this.props.Height;

        return <div className="tooltip" style={{ marginLeft: "0px" }}>
            <img
                src={"images/" + baseName + ".png"}
                alt={"(images/" + baseName + ".png)"}
                height={high}
                width={wide}
                onClick={this.onClick.bind(this)}
                onMouseOut={this.mouseOutHandler.bind(this)}
                onMouseOver={e => this.mouseOverHandler(e)}
                onMouseDown={e => e.currentTarget.src = 'images/' + baseName + 'Pressed.png'}
                onMouseUp={e => e.currentTarget.src = 'images/' + baseName + 'Hover.png'}
                style={{ cursor: "pointer" }} />
            <span className="tooltiptext">{this.props.TooltipText}</span>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./client/view/ImageButton.tsx